import apiService from "../api/api.service";
import { CompanyPayrollResponse, PayrollUserDetails } from "../../types/payroll.types";

class PayrollService {
  private static instance: PayrollService;

  private constructor() { }

  public static getInstance(): PayrollService {
    if (!PayrollService.instance) {
      PayrollService.instance = new PayrollService();
    }
    return PayrollService.instance;
  }

  public async getUserPayroll(userId: number, year: number, month: number): Promise<PayrollUserDetails> {
    const response = await apiService.get<PayrollUserDetails>(`/payroll/user/${userId}/${year}/${month}`);
    return response;
  }

  public async getCompanyPayroll(companyId: number, year: number, month: number): Promise<CompanyPayrollResponse> {
    const response = await apiService.get<CompanyPayrollResponse>(`/payroll/company/${companyId}/${year}/${month}`);
    return response;
  }
}

export default PayrollService.getInstance();


